import { ReportFeatures } from '@hcs/types';

export const SELECTED_OR_SUGGESETED_COMPS_CARDS_FEATURES_SALE = [
  ReportFeatures.CompsHcSuggested,
  ReportFeatures.CompsSelect,
];
export const SELECTED_OR_SUGGESETED_COMPS_CARDS_FEATURES_RENTAL = [
  ReportFeatures.RentalCompsHcSuggested,
  ReportFeatures.RentalCompsSelect,
];
